import React, { useState } from "react";
import Button from "../components/base/Button.jsx";
import Input from "../components/base/Input.jsx";
import Label from "../components/base/Label.jsx";
import { API_URL } from "../utils/constants.js";
import { theme } from "../theme.js";

export default function Contact() {
  const [formData, setFormData] = useState({ email: "", subject: "", html: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const canSend = formData.email.trim() && formData.subject.trim() && formData.html.trim() && !sending;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError("");
    setSent(false);
    try {
      // TODO: Replace with your backend endpoint
      const res = await fetch(`${API_URL}/api/emails/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (!res.ok) throw new Error("Erreur lors de l'envoi");
      setSent(true);
      setFormData({ email: "", subject: "", html: "" });
    } catch (err) {
      setError(err.message || "Erreur inconnue");
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.titleStyle}>Contact</h2>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: theme.spacing.md }}>
        
          <Input
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            setFormData={setFormData}
            required
            autoComplete="email"
            placeholder="Votre email"
            />
          <Input
            label="Objet"
            name="subject"
            type="text"
            value={formData.subject}
            setFormData={setFormData}
            required
            placeholder="Sujet du message"
          />
        <Label label="Message" style={styles.labelStyle} required={true}/>          
          <textarea
            value={formData.html}
            onChange={e => setFormData({ ...formData, html: e.target.value })}
            style={{ ...styles.inputStyle, minHeight: 120, fontFamily: theme.fonts.family.primary }}
            required
            placeholder="Votre message"
          />
        <Button
          type="submit"
          title={sending ? "Envoi..." : sent ? "Envoyé !" : "Envoyer"}
          style="dark"
          disabled={!canSend}
        />
        {error && <div style={{ color: theme.colors.error, marginTop: theme.spacing.sm }}>{error}</div>}
        {sent && <div style={{ color: theme.colors.success, marginTop: theme.spacing.sm }}>Message envoyé !</div>}
      </form>
    </div>
  );
}

const styles = {

page:{ 
    color: theme.colors.dark, 
    fontSize: theme.fonts.size.xl, 
    marginBottom: theme.spacing.lg,
    width:"100%",
    padding: theme.spacing.xxl,
    display: "flex",
    flexDirection: "column",},

titleStyle:{
    color: theme.colors.dark, 
    fontSize: theme.fonts.size.xl, 
    marginBottom: theme.spacing.lg 
},
labelStyle: {
    color: theme.colors.textInverted,
    fontWeight: theme.fonts.weight.medium,
    fontSize: theme.fonts.size.sm,
    marginBottom: theme.spacing.xs,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xs,
    },

inputStyle: {
padding: theme.spacing.sm,
border: `1px solid ${theme.colors.border}`,
borderRadius: theme.radius.md,
fontSize: theme.fonts.size.md,
marginTop: theme.spacing.xs,
fontFamily: theme.fonts.family.primary,
color: theme.colors.dark,
background: theme.colors.bgLight,
outline: "none",
transition: `border-color ${theme.transitions.base}`,
},

};
